var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResetCameraIcon = function SvgResetCameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-8 4h2v10h-2zm4 8h2v2h-2zm0-2h2v2h-2zm0-2h2v2h-2zm0-2h2v2h-2zm0-2h2v2h-2zM7 7h2v2H7zm0 2h2v2H7zm0 2h2v2H7zm0 2h2v2H7zm0 2h2v2H7z"
  })));
};
export default SvgResetCameraIcon;